import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const LocationFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
      fill="currentColor"
    />
  </svg>
);

LocationFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(LocationFilledIcon);
